import React from 'react';
import { Container } from 'react-bootstrap'

import "./page-banner.css";
function PageBanner(props) {
	return (
		<>
			<div className="page-banner">
				<Container className="d-flex align-items-center">
					<div className="banner-content">
						<h1 className="mb-2 mb-md-3">{props.title}</h1>
						<p>{props.subHeading}</p>
					</div>
				</Container>
			</div>
		</>
	);
}

export default PageBanner;
